import { render, staticRenderFns } from "./BaseLayoutModifier.vue?vue&type=template&id=110b8564&"
import script from "./BaseLayoutModifier.vue?vue&type=script&lang=ts&"
export * from "./BaseLayoutModifier.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports